class GalleryShowcase {
  constructor(element) {
    this.element = element;
    this.mediaWrapper = element.querySelector('.gallery-showcase__media-wrapper');
    this.slides = Array.from(element.querySelectorAll('.js-gallery-slide'));
    this.prevButton = element.querySelector('.js-gallery-prev');
    this.nextButton = element.querySelector('.js-gallery-next');
    this.progressBar = element.querySelector('.js-gallery-progress-bar');
    
    this.currentIndex = 0;
    this.autoplay = element.dataset.autoplay !== 'false'; // Default to true if not specified
    this.duration = parseInt(element.dataset.duration) * 1000 || 5000;
    this.interval = null;

    if (this.slides.length > 1) {
      this.init();
    }
  }

  init() {
    // Bind event listeners for controls (if they exist)
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.prev());
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.next());
    }

    // Click anywhere on media wrapper to advance to next slide
    if (this.mediaWrapper) {
      this.mediaWrapper.addEventListener('click', () => this.next());
      
      // Pause on hover over media wrapper only
      this.mediaWrapper.addEventListener('mouseenter', () => this.pause());
      this.mediaWrapper.addEventListener('mouseleave', () => this.resume());
    }

    // Set initial progress
    this.updateProgress();

    // Start autoplay (default to enabled)
    if (this.autoplay) {
      this.play();
    }

    // Handle videos
    this.handleVideo();
  }

  goToSlide(index) {
    // Pause all videos
    this.pauseAllVideos();

    // Remove active class from current slide
    this.slides[this.currentIndex].classList.remove('is-active');

    // Update current index
    this.currentIndex = index;
    if (this.currentIndex < 0) {
      this.currentIndex = this.slides.length - 1;
    } else if (this.currentIndex >= this.slides.length) {
      this.currentIndex = 0;
    }

    // Add active class to new slide
    this.slides[this.currentIndex].classList.add('is-active');

    // Handle video for new slide
    this.handleVideo();

    // Update progress bar to show current slide position
    this.updateProgress();
  }

  next() {
    this.goToSlide(this.currentIndex + 1);
  }

  prev() {
    this.goToSlide(this.currentIndex - 1);
  }

  play() {
    this.pause(); // Clear any existing intervals
    
    this.interval = setInterval(() => {
      this.next();
    }, this.duration);
  }

  pause() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  resume() {
    if (this.autoplay) {
      this.play();
    }
  }

  updateProgress() {
    if (this.progressBar) {
      // Calculate progress based on current slide position
      const progress = ((this.currentIndex + 1) / this.slides.length) * 100;
      this.progressBar.style.width = progress + '%';
    }
  }

  handleVideo() {
    const currentSlide = this.slides[this.currentIndex];
    const video = currentSlide.querySelector('video');
    
    if (video) {
      video.currentTime = 0;
      video.play().catch(() => {
        // Video play failed, continue with slideshow
      });
    }
  }

  pauseAllVideos() {
    this.slides.forEach(slide => {
      const video = slide.querySelector('video');
      if (video) {
        video.pause();
      }
    });
  }
}

// Initialize all gallery showcases
document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('.js-gallery-showcase');
  galleries.forEach(gallery => {
    new GalleryShowcase(gallery);
  });
});

